const ContestPage = () => null;

export default ContestPage;
